var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"field",staticClass:"currency-input",attrs:{"outlined":"","suffix":_vm.prefix,"error-messages":_vm.errorMessages},on:{"focus":_vm.onFocus,"keyup":_vm.onKeyUp,"change":_vm.onChange,"blur":_vm.onBlur},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }